#!/usr/bin/env node

require('dotenv').config();
const { program } = require('commander');
program.version(require(require('path').join(__dirname, '../../package.json')).version);

require('./commands/base')(program);
require('./commands/make')(program);
require('./commands/migrate')(program);
require('./commands/dev')(program);

program.parseAsync(process.argv).then(() => {
    process.exit()
}).catch(err => {
    console.error(err);
    process.exit(-1)
});
